export default __webpack_public_path__ + "static/media/POKOPIPO.155dbab1.jpeg";